import { render } from "./EditPostActions.vue?vue&type=template&id=60096b96&scoped=true"
import script from "./EditPostActions.vue?vue&type=script&lang=js"
export * from "./EditPostActions.vue?vue&type=script&lang=js"

import "./EditPostActions.vue?vue&type=style&index=0&id=60096b96&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\wordpress\\wp-content\\themes\\yka-theme-2022\\vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60096b96"]])

export default __exports__